<app-navbar *ngIf="!embedded"></app-navbar>

<!-- Remove-from-list confirm dialog -->
<div *ngIf="deleteConfirmTestId !== null" class="confirm-dialog-overlay" (click)="closeDeleteConfirm()"></div>
<div *ngIf="deleteConfirmTestId !== null" class="confirm-dialog" role="dialog" aria-labelledby="removeSharedConfirmLabel" aria-modal="true">
  <div class="confirm-dialog-content" (click)="$event.stopPropagation()">
    <div class="confirm-dialog-header">
      <h5 class="confirm-dialog-title" id="removeSharedConfirmLabel"><i class="bi bi-trash text-danger"></i> Remove from list</h5>
      <button type="button" class="btn-close" (click)="closeDeleteConfirm()" [disabled]="deleteConfirmLoading" aria-label="Close"></button>
    </div>
    <div class="confirm-dialog-body">
      <p class="confirm-dialog-message mb-0">Remove this shared test from your list? You will no longer see it here.</p>
    </div>
    <div class="confirm-dialog-footer">
      <button type="button" class="btn btn-secondary" (click)="closeDeleteConfirm()" [disabled]="deleteConfirmLoading">Cancel</button>
      <button type="button" class="btn btn-danger" (click)="doRemoveShared(); $event.stopPropagation()" [disabled]="deleteConfirmLoading">
        <span *ngIf="deleteConfirmLoading" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
        <span *ngIf="!deleteConfirmLoading">Remove</span>
      </button>
    </div>
  </div>
</div>

<div class="shared-tests-layout" [class.shared-tests-embedded]="embedded">
  <a *ngIf="!embedded" routerLink="/dashboard" class="back-link">
    <i class="bi bi-arrow-left"></i> Back to Dashboard
  </a>

  <h1 *ngIf="!embedded" class="page-title">Shared Tests</h1>
  <p *ngIf="!embedded" class="page-subtitle">Tests that <strong>other users have shared with you</strong>. Recreate, view report, or remove from your list.</p>

  <!-- Filter panel: All, Study, Exam, Filter by Subject - all in one panel -->
  <div class="panel filter-panel">
    <div class="filter-row">
      <div class="filter-group">
        <label class="filter-label">Test Mode</label>
        <div class="mode-buttons" role="group" id="sharedModeSwitch">
          <input type="radio" class="btn-check" name="sharedMode" id="sharedModeAll" value="all"
                 [(ngModel)]="selectedMode" (change)="onFilterChange()" [checked]="selectedMode === 'all'">
          <label class="mode-btn" for="sharedModeAll">All</label>
          <input type="radio" class="btn-check" name="sharedMode" id="sharedModeStudy" value="test"
                 [(ngModel)]="selectedMode" (change)="onFilterChange()" [checked]="selectedMode === 'test'">
          <label class="mode-btn" for="sharedModeStudy">Study</label>
          <input type="radio" class="btn-check" name="sharedMode" id="sharedModeExam" value="exam"
                 [(ngModel)]="selectedMode" (change)="onFilterChange()" [checked]="selectedMode === 'exam'">
          <label class="mode-btn" for="sharedModeExam">Exam</label>
        </div>
      </div>
      <div class="filter-group">
        <label class="filter-label" for="subjectFilter">Filter by Subject</label>
        <select class="form-select" id="subjectFilter" [(ngModel)]="selectedSubjectName" (change)="onFilterChange()">
          <option [ngValue]="null">All Subjects</option>
          <option *ngFor="let subj of availableSubjects" [ngValue]="subj.name">{{ subj.name }}</option>
        </select>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading" class="text-center py-5">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <!-- Content -->
  <div *ngIf="!isLoading">
    <div *ngIf="filteredTests.length === 0" class="panel">
      <p class="text-muted mb-0">No tests have been shared with you.</p>
    </div>

    <div *ngIf="filteredTests.length > 0">
      <p class="table-count">Showing {{ filteredTests.length }} test{{ filteredTests.length === 1 ? '' : 's' }}</p>
      <div class="table-wrapper">
        <div class="table-responsive">
          <table class="table table-hover tests-table">
            <thead>
              <tr>
                <th (click)="onSort('subjectName')" class="sortable">Subject <i class="bi" [ngClass]="getSortIcon('subjectName')"></i></th>
                <th class="col-shared-by">Shared by</th>
                <th (click)="onSort('mode')" class="sortable col-mode">Mode <i class="bi" [ngClass]="getSortIcon('mode')"></i></th>
                <th (click)="onSort('questionCount')" class="sortable col-questions"><span class="header-full">Questions</span><span class="header-short">QU.</span> <i class="bi" [ngClass]="getSortIcon('questionCount')"></i></th>
                <th (click)="onSort('completed')" class="sortable col-completed"><span class="header-full">Completed</span><span class="header-short">COMPL.</span> <i class="bi" [ngClass]="getSortIcon('completed')"></i></th>
                <th (click)="onSort('score')" class="sortable">Score <i class="bi" [ngClass]="getSortIcon('score')"></i></th>
                <th (click)="onSort('savedDate')" class="sortable col-date">Saved Date <i class="bi" [ngClass]="getSortIcon('savedDate')"></i></th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let test of filteredTests" [attr.data-testid]="'shared-test-row-' + test.id" [class.shared-test-locked]="!isAccessible(test)">
                <td class="col-subject">
                  <div class="subject-cell">
                    <span>{{ test.subjectName }}</span>
                    <span *ngIf="test.subjectNames && test.subjectNames.length > 1" class="ms-1" [title]="getOtherSubjectsTooltip(test)">
                      <i class="bi bi-info-circle text-muted" aria-hidden="true"></i>
                    </span>
                    <span class="mode-badge mode-badge-mobile" [class.mode-study]="test.mode === 'test'" [class.mode-exam]="test.mode === 'exam'">
                      {{ formatMode(test.mode) }}
                    </span>
                  </div>
                </td>
                <td class="col-shared-by">{{ test.sharedByUsername ?? '—' }}</td>
                <td class="col-mode">
                  <span class="mode-badge mode-badge-desktop" [class.mode-study]="test.mode === 'test'" [class.mode-exam]="test.mode === 'exam'">
                    {{ formatMode(test.mode) }}
                  </span>
                </td>
                <td>{{ test.questionCount }}</td>
                <td>{{ formatCompleted(test.completedCount, test.questionCount) }}</td>
                <td>{{ formatScore(test.score) }}</td>
                <td class="col-date"><span class="date-full">{{ formatDate(test.savedDate) }}</span><span class="date-short">{{ formatDateShort(test.savedDate) }}</span></td>
                <td>
                  <p *ngIf="!isAccessible(test)" class="shared-access-hint mb-2">{{ accessHint(test) }}</p>
                  <div class="action-buttons">
                    <span [title]="isAccessible(test) ? 'Recreate test with same settings' : accessHint(test)" class="d-inline-block">
                      <button type="button" class="btn btn-primary btn-sm btn-recreate"
                              (click)="onRecreate(test.id)"
                              [disabled]="!isAccessible(test)"
                              [attr.data-testid]="'shared-recreate-btn-' + test.id">
                        <i class="bi bi-play-fill btn-icon-only"></i> Recreate
                      </button>
                    </span>
                    <span [title]="!isAccessible(test) ? accessHint(test) : (isAllCompleted(test.completedCount, test.questionCount) ? 'View report' : 'No report available, test was not finished')" class="d-inline-block">
                      <button type="button" class="btn btn-sm btn-icon btn-icon-report"
                              (click)="onTestReport(test.id)"
                              [disabled]="!isAccessible(test) || !isAllCompleted(test.completedCount, test.questionCount)">
                        <i class="bi bi-file-text btn-icon-only"></i><span class="btn-text-only">Report</span>
                      </button>
                    </span>
                    <button type="button" class="btn btn-sm btn-icon btn-icon-delete"
                            (click)="openDeleteConfirm(test.id)"
                            title="Remove from my shared list">
                      <i class="bi bi-trash btn-icon-only"></i><span class="btn-text-only">Delete</span>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
